import React, { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Flex } from 'components';
import { useSchool } from 'features/school';
import { useBreakpoints } from 'app/hooks';

const AppLayout = (): ReactElement => {
  const { schoolAlias } = useSchool();
  const breakpoint = useBreakpoints();

  return (
    <Flex
      className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`}
      width="100vw"
      minHeight="100vh"
      flexDirection="column"
      flexWrap="nowrap"
      bg="dark_150"
    >
      <Outlet />
    </Flex>
  );
};

export default AppLayout;
